import { OutputData } from '@editorjs/editorjs'

export const hasValidContentBlocks = (content?: OutputData | null) => {
	if (!content || !content?.blocks?.length) {
		return false
	}

	const areAllBlocksText = content.blocks.every(
		block => block.type === 'paragraph' || block.type === 'header'
	)

	if (areAllBlocksText) {
		return !content.blocks.every(block => block.data?.text === '' || block.data?.text === null)
	}

	return true
}
